class ThemeService {
  constructor () {
    this.currentTheme = 'fractel'
    this.themes = {
      fractel: {
        name: 'FracTEL',
        logo: 'assets/fractel/rect_logo.png',
        primaryColor: '#009AB1',
        secondaryColor: '#005CAD',
        darkColor: '#004b56',
        company: 'FracTEL, LLC',
        companyUrl: 'https://fractel.com'
      },
      fonestorm: {
        name: 'FoneStorm',
        logo: 'assets/fonestorm/rect_logo.png',
        primaryColor: '#009AB1',
        secondaryColor: '#005CAD',
        darkColor: '#004b56',
        company: 'FoneStorm, Inc',
        companyUrl: 'https://fonestorm.ai'
      }
    }
  }

  detectThemeFromDomain () {
    const hostname = window.location.hostname

    if (hostname.includes('fonestorm')) {
      return 'fonestorm'
    } else if (hostname.includes('fractel')) {
      return 'fractel'
    }

    // Default to fractel
    return 'fractel'
  }

  setTheme (themeName) {
    this.currentTheme = themeName
    const theme = this.themes[themeName]

    if (!theme) return

    // Update CSS custom properties
    const root = document.documentElement
    root.style.setProperty('--brand-primary', theme.primaryColor)
    root.style.setProperty('--brand-secondary', theme.secondaryColor)
    root.style.setProperty('--brand-dark', theme.darkColor)
    root.style.setProperty('--sidebar-bg', theme.primaryColor)
    root.style.setProperty('--dropdown-bg', theme.primaryColor)
    root.style.setProperty('--tooltip-bg', theme.primaryColor)
    root.style.setProperty('--vue-green', theme.primaryColor)
    root.style.setProperty('--theme-blue', theme.primaryColor)

    // Update body class for theme-specific styles
    document.body.className = document.body.className.replace(/\b(fractel|fonestorm)-theme\b/g, '')
    document.body.classList.add(`${themeName}-theme`)

    // Store theme in localStorage
    localStorage.setItem('app-theme', themeName)
    localStorage.setItem('branding-name', theme.name)
    localStorage.setItem('branding-logo', theme.logo)
  }

  getCurrentTheme () {
    return this.themes[this.currentTheme]
  }

  initializeTheme () {
    // Check localStorage first, then domain
    const storedTheme = localStorage.getItem('app-theme')
    const domainTheme = this.detectThemeFromDomain()

    const theme = storedTheme || domainTheme
    this.setTheme(theme)

    return theme
  }
}

export default new ThemeService()



// WEBPACK FOOTER //
// ./src/services/ThemeService.js